import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Select, Card, Spin, Row, Col } from 'antd';
import { toast } from 'react-toastify';
import authService from '../../api/auth';
import enumService from '../../api/enumService';

const { Option } = Select;

const UserSignup = () => {
  const [loading, setLoading] = useState(false);
  const [roleTypes, setRoleTypes] = useState([]);
  const [userTypes, setUserTypes] = useState([]);

  useEffect(() => {
    fetchRoleTypes();
    fetchUserTypes();
  }, []);

  const fetchRoleTypes = async () => {
    setLoading(true);
    const response = await enumService.getRoleTypes();
    if (!response.success) {
      toast.error(response.message);
    } else {
      setRoleTypes(response.data.data);
    }
    setLoading(false);
  };

  const fetchUserTypes = async () => {
    setLoading(true);
    const response = await enumService.getUserTypes();
    if (!response.success) {
      toast.error(response.message);
    } else {
      setUserTypes(response.data.data);
    }
    setLoading(false);
  };

  const onFinish = async (values) => {
    delete values.confirmPassword;
    setLoading(true);
    const response = await authService.signup(values);
    if (response.success) {
      toast.success('Signup successful!');
    } else {
      toast.error(response.message || 'Signup failed');
    }
    setLoading(false);
  };

  return (
    <Row justify="center" align="middle" style={{ minHeight: '100vh', padding: '1rem' }}>
      <Col xs={24} sm={20} md={16} lg={10}>
        <Card title="User Signup" bordered={false}>
          <Spin spinning={loading}>
            <Form layout="vertical" onFinish={onFinish}>
              <Form.Item
                label="Username"
                name="username"
                rules={[{ required: true, message: 'Please input your username!' }]}
              >
                <Input placeholder="Enter username" />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: 'Please input your password!' }]}
                hasFeedback
              >
                <Input.Password placeholder="Enter password" />
              </Form.Item>

              <Form.Item
                label="Confirm Password"
                name="confirmPassword"
                dependencies={['password']}
                hasFeedback
                rules={[
                  { required: true, message: 'Please confirm your password!' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Passwords do not match!'));
                    },
                  }),
                ]}
              >
                <Input.Password placeholder="Confirm password" />
              </Form.Item>

              <Form.Item
                label="Role"
                name="role"
                rules={[{ required: true, message: 'Please select a role!' }]}
              >
                <Select placeholder="Select a role">
                  {roleTypes.map((role) => (
                    <Option key={role} value={role}>
                      {role}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="User Type"
                name="userType"
                rules={[{ required: true, message: 'Please select a user type!' }]}
              >
                <Select placeholder="Select a user type">
                  {userTypes.map((type) => (
                    <Option key={type} value={type}>
                      {type}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Sign Up
                </Button>
              </Form.Item>
            </Form>
          </Spin>
        </Card>
      </Col>
    </Row>
  );
};

export default UserSignup;
